import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  cardDetails: { display: 'flex', fontSize: '0.875rem', lineHeight: '1.375rem' },
  cardDetailsTitle: { marginRight: '0.25rem', fontWeight: 700 },
  defaultDisclaimer: {
    color: theme.palette.text.secondary,
    display: 'flex',
  },
  warning: {
    marginLeft: 'auto',
    color: theme.palette.error.main,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '24px',
  },
  header: {
    display: 'flex',
  },
  helpIcon: {
    fontSize: 16,
    marginLeft: 5,
  },
  input: {
    // Height fix to match Material Select
    height: 31,
  },
  modalInput: {
    fontSize: 14,
    fontWeight: '700',
    lineHeight: '33px',
    letterSpacing: '0em',
  },
  modalInputMultiline: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: '700',
    letterSpacing: '0em',
  },
  addBufferButton: {
    textTransform: 'none',
    marginLeft: 'auto',
  },
  tooltip: {
    maxWidth: 250,
  },
  tooltipContainer: {
    padding: '10px 0px 0px 10px',
  },
  deleteTooltipButton: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.primary.active,
  },
  bufferCalculation: {
    color: theme.palette.primary.dark,
    display: 'flex',
    alignItems: 'center',
  },
  bufferCalculationDetails: {
    color: theme.palette.primary.infoAlert,
  },
  accordionSummaryRoot: {
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  accordionSummaryContent: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
}));

export const noUnderLine = makeStyles((theme) => ({
  root: {
    '& .MuiInput-underline:before': {
      borderBottomColor: 'transparent !important',
    },
  },
}));
